import { render, staticRenderFns } from "./FrontPagePopUp.vue?vue&type=template&id=363f5e5b&"
import script from "./FrontPagePopUp.vue?vue&type=script&lang=js&"
export * from "./FrontPagePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports